class AccordionGroup extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.items = this.querySelectorAll(".accordion--item");

    this.items.forEach((item) => {
      const header = item.querySelector(".accordion--header");
      const content = item.querySelector(".accordion--content");

      if (!header || !content) return;

      header.addEventListener("click", () => {
        this.closeOthers(item);
        this.toggleItem(item, content);
      });
    });
  }

  closeOthers(currentItem) {
    this.items.forEach((item) => {
      if (item !== currentItem) {
        item.classList.remove("active");
        const content = item.querySelector(".accordion--content");
        if (content) content.style.maxHeight = null;
      }
    });
  }

  toggleItem(item, content) {
    const isActive = item.classList.toggle("active");

    if (isActive) {
      content.style.maxHeight = content.scrollHeight + "px";
    } else {
      content.style.maxHeight = null;
    }
  }
}

customElements.define("accordion-group", AccordionGroup);